import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public http: HttpClient) { }
  
  basUrl = environment.baseUrl
  getSingleTaskTask(opts: any): Observable<any[]> {
    console.log('--------------------- opts ---------------------', opts)
    return this.http.post<any[]>(this.basUrl+'task/tracking', opts);
  }

  submitDriverRating(ratingData: any): Observable<any> {
    console.log('--------------------- ratingData ---------------------', ratingData)
    return this.http.post<any>(this.basUrl + 'driver/rating', ratingData);
  }
}
